import React, { useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Datagrid, Error, Loading, useQuery, useTranslate } from 'react-admin'
import { useSelector } from 'react-redux'

import tracker from '../../utils/tracker'
import { CollectionEmpty } from '../emptyViews/collectionEmptyView'
import { EventsCollectionExpandableView } from '../expandableViews/eventsCollectionExpandableView'
import { CurrencyField } from '../fields/currencyField'
import { LocalDateField } from '../fields/localDateField'
import { PaymentPayerField } from '../fields/paymentPayerField'
import { CustomDatagridBody } from './customDatagridBody'
import { CustomDatagridRow } from './customDatagridRow'

const SORT = {
  field: 'expires_at',
  order: 'DESC',
}

const useStyles = makeStyles((theme) => ({
  date: {
    whiteSpace: 'nowrap',
    paddingRight: '40px',
  },
  headerRightWithoutIcon: {
    textAlign: 'right',
    paddingRight: '120px!important',
  },
  description: {},
  scrollPanelWithSidebarClosed: {
    display: 'flex',
    overflowY: 'auto',
    overflowX: 'auto',
    width: 'calc(100vw - 200px)',
    maxHeight: 'calc(95vh - 250px)',
  },
  scrollPanelWithSidebarOpened: {
    display: 'flex',
    overflowY: 'auto',
    overflowX: 'auto',
    width: 'calc(100vw - 300px)',
    maxHeight: 'calc(95vh - 250px)',
  },
  [theme.breakpoints.down('sm')]: {
    scrollPanel: {
      maxWidth: '80vw',
    },
  },
}))

export const CollectionDatagrid = (props) => {
  const classes = useStyles()
  const open = useSelector((state) => state.admin.ui.sidebarOpen)
  const translate = useTranslate()

  const { data, error } = useQuery({
    type: 'getList',
    resource: 'creditlines',
    payload: {
      pagination: { page: 1, perPage: 10 },
      sort: SORT,
    },
  })

  const { total, loading } = props

  useEffect(() => {
    if (props.onChangeList)
      props.onChangeList({
        total,
        loading,
      })
  }, [total, loading, props])

  if (!total && !loading) {
    return <CollectionEmpty />
  }

  if (error) return <Error error={error} />

  if (loading) return <Loading className={classes.scrollPanel} />

  const handleUserExpand = (props) => {
    tracker.event({
      action: `collection_details_expanded`,
      category: `collections`,
      label: props.record ? props.record.reference : undefined,
    })
  }

  const handleUserCollapse = (props) => {
    tracker.event({
      action: `collection_details_collapsed`,
      category: `collections`,
      label: props.record ? props.record.reference : undefined,
    })
  }

  return (
    <div
      className={
        open
          ? classes.scrollPanelWithSidebarOpened
          : classes.scrollPanelWithSidebarClosed
      }
    >
      <Datagrid
        {...props}
        expand={<EventsCollectionExpandableView />}
        body={
          <CustomDatagridBody
            {...props}
            row={
              <CustomDatagridRow
                {...props}
                onUserExpand={handleUserExpand}
                onUserCollapse={handleUserCollapse}
              />
            }
          />
        }
      >
        <LocalDateField
          source={'deposited_at'}
          label={'resources.payments.payment.date'}
        />
        <PaymentPayerField
          source={'type'}
          sourceType={'Collection'}
          sourceImporterName="from"
          sourceCreditLine="creditLine"
          label={'resources.payments.payment.importerName'}
          linkDataCreditLines={data}
        />
        <Typography label={'resources.payments.payment.description'}>
          <span className={classes.descriptionField}>
            {translate(
              'resources.invoices.events.collectionReceivedDescription'
            )}
          </span>
        </Typography>
        <CurrencyField
          source={'amount'}
          label={'resources.payments.payment.amount'}
          className={classes.date}
          headerClassName={classes.headerRightWithoutIcon}
        />
      </Datagrid>
    </div>
  )
}
